import React from 'react'
import { withRouter } from "react-router-dom";
import { TableOp } from '../../../components/table/TableOps.tsx';
import TableComponent from '../../../components/table/TableOps';
import Estado from './Estado.js';

class Estados extends TableComponent {

  componentDidMount() {
    this.tableConfig(
      { dataUrl: 'estado/filter', deleteUrl: 'estado/delete', deleteField: 'estado', modUrl: '/Catalogo/Estado' },
      TableOp.Table('Estados', [
        { label: 'Estado', id: 'estado' },
        // { label: 'Estado', id: 'estado_nombre' },
      ], [])
    );
    this.table();
  }

  render() {
    return (
      <div>
        <div>
          {
             
          <Estado  onSave={() => { this.table() }}></Estado>
        }
        {
           
          <this.TableRender  />
        }
        </div>
      </div>
    )
  }
}

export default withRouter(Estados);